export type TrainStatus = 0 | 1 | 2 | 3;
export enum TrainStatusEnum {
  UnTrain = 0,
  Training = 1,
  Success = 2,
  Failed = 3,
}
export const trainStatusMap = {
  [TrainStatusEnum.UnTrain]: '未训练',
  [TrainStatusEnum.Success]: '训练成功',
  [TrainStatusEnum.Failed]: '训练失败',
  [TrainStatusEnum.Training]: '训练中',
};
export const trainStatusColorMap = {
  [TrainStatusEnum.UnTrain]: 'gray',
  [TrainStatusEnum.Success]: 'green',
  [TrainStatusEnum.Failed]: 'red',
  [TrainStatusEnum.Training]: 'blue',
};

export const trainActionStatusMap = {
  [TrainStatusEnum.UnTrain]: '一键训练',
  [TrainStatusEnum.Success]: '一键训练',
  [TrainStatusEnum.Failed]: '一键训练',
  [TrainStatusEnum.Training]: '停止训练',
};
